import { render, staticRenderFns } from "./MultiSelectSettings.vue?vue&type=template&id=1f4bcd7c&scoped=true"
import script from "./MultiSelectSettings.vue?vue&type=script&lang=js"
export * from "./MultiSelectSettings.vue?vue&type=script&lang=js"
import style0 from "./MultiSelectSettings.vue?vue&type=style&index=0&id=1f4bcd7c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4bcd7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f4bcd7c')) {
      api.createRecord('1f4bcd7c', component.options)
    } else {
      api.reload('1f4bcd7c', component.options)
    }
    module.hot.accept("./MultiSelectSettings.vue?vue&type=template&id=1f4bcd7c&scoped=true", function () {
      api.rerender('1f4bcd7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/content/MultiSelectSettings.vue"
export default component.exports